import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import moment from "moment";
import DateBlock from '../home/DateBlock';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import "./_studentPermission.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown'
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import { components } from 'react-select'
import PermissionDetailsModal from './PermissionDetailsModal';
import MultipleRequestModal from './MultipleRequestModal';
import SingleRequestModal from './SingleRequestModal';
import PermissionModal from './studentPermissionModal';
import MultiSelect from "react-multi-select-component";

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
      </components.DropdownIndicator>
    )
  );
};

class StudentPermissionHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branchSearch: "0",
      branchSearchval: "",
      permissiontypeSearch: "0",
      permissiontypeSearchval: "",
      loadingSpinner: 0,
      viewDetailsModal: false,
      viewMultipleRequestModal: false,
      viewSingleRequestModal: false,
      permissionModalShow: false,
      individualPermissionData: [],
      blockType: "1",
      studentsTotalList: 0,
      sendStudentsNotificationList: [],
      startDateCalender: moment(new Date()).subtract(5, "days").startOf('day').unix(),
      endDateCalender: moment(new Date()).endOf('day').unix(),
      noDateError: "",
      template_name: "",
      getExamArr: [],
      examSelectedvalue: [],
      examSearch: "0",
      getClassArr: [],
      classSearch: "0",
      classSelectedvalue: [],
      getSectionArr: [],
      sectionSearch: "0",
      sectionSelectedvalue: [],
    }
  }

  componentDidMount() {
    let getArray = [];
    this.props.getPermissionRequestTypes.map((item) => {
      const newObj = {
        value: item.id,
        label: item.permission_request_type
      }
      getArray.push(newObj);
    });

    this.setState({
      permissiontypeSearchval: getArray[0],
      permissiontypeSearch: getArray[0].value
    })

    let getArray1 = [];
    this.props.globals.globalBranches.map((item) => {
      const newObj = {
        value: item.id,
        label: item.branch_name
      }
      getArray1.push(newObj);
    });
    this.setState({
      branchSearchval: getArray1[0],
      branchSearch: getArray1[0].value
    })

    let branchData = this.props.globals.globalBranches;

    let getExamArr = [];
    let getClassArr = [];
    let getSectionArr = [];

    if (branchData.length > 0) {
      // Exams selection
      let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id).map((item1) => item1.exam_id))].sort();

      uniqueExams.map((val) => {
        let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
        const newObj = {
          value: individualExamData.id,
          label: individualExamData.exam
        }
        getExamArr.push(newObj);
      });

      //Class selection

      let selectedExamsValues = getExamArr.map((item) => item.value);

      let uniqueClasses = [];

      if (selectedExamsValues.length > 0) {

        selectedExamsValues.map((val) => {
          let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
          uniqueClasses.push(...individualClassValues)
        });
      }

      if (uniqueClasses.length > 0) {
        [...new Set(uniqueClasses)].map((val) => {
          let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
          const newObj = {
            value: individualClassData.id,
            label: individualClassData.class
          }
          getClassArr.push(newObj);
        });

        let selectedClasses = getClassArr.map((item) => item.value);


        //section selection

        let uniqueSections = [];

        if (selectedClasses.length > 0) {
          selectedExamsValues.map((val) => {
            selectedClasses.map((val1) => {
              let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
              if (individualsectionValues.length > 0) {
                uniqueSections.push(...individualsectionValues)
              }
            })
          });
        }

        if (uniqueSections.length > 0) {
          [...new Set(uniqueSections)].map((val) => {
            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
            const newObj = {
              value: individualSectionData.id,
              label: individualSectionData.section_name
            }
            getSectionArr.push(newObj);
          });
        }
      }
      this.setState({
        branchSearchval: {
          value: branchData[0].id,
          label: branchData[0].branch_name
        },
        branch: branchData[0].branch_name,
        branchSearch: branchData[0].id,
        getExamArr: getExamArr,
        examSelectedvalue: getExamArr,
        getClassArr: getClassArr,
        classSelectedvalue: getClassArr,
        getSectionArr: getSectionArr,
        sectionSelectedvalue: getSectionArr,
      });
    }

  }

  selecthandleInputChange = (ename, evalue, e) => {
    console.log("nnnnn", e, ename);
    const name = ename;
    const value = evalue;
   
    //branch
    if (name == "branchSearch") {
      if (value != "0") {
        let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
        console.log("branchSearchData", branchSearchData);

        let getExamArr = [];
        let getClassArr = [];
        let getSectionArr = [];

        if (branchSearchData != null) {
          // Exams selection
          let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id).map((item1) => item1.exam_id))].sort();

          uniqueExams.map((val) => {
            let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
            const newObj = {
              value: individualExamData.id,
              label: individualExamData.exam
            }
            getExamArr.push(newObj);
          });


          let selectedExamsValues = getExamArr.map((item) => item.value);

          let uniqueClasses = [];

          if (selectedExamsValues.length > 0) {

            selectedExamsValues.map((val) => {
              let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
              uniqueClasses.push(...individualClassValues)
            });
          }

          if (uniqueClasses.length > 0) {
            [...new Set(uniqueClasses)].map((val) => {
              let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
              const newObj = {
                value: individualClassData.id,
                label: individualClassData.class
              }
              getClassArr.push(newObj);
            });

            let selectedClasses = getClassArr.map((item) => item.value);


            //section selection

            let uniqueSections = [];

            if (selectedClasses.length > 0) {
              selectedExamsValues.map((val) => {
                selectedClasses.map((val1) => {
                  let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                  if (individualsectionValues.length > 0) {
                    uniqueSections.push(...individualsectionValues)
                  }
                })
              });
            }

            if (uniqueSections.length > 0) {
              [...new Set(uniqueSections)].map((val) => {
                let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                const newObj = {
                  value: individualSectionData.id,
                  label: individualSectionData.section_name
                }
                getSectionArr.push(newObj);
              });
            }
          }

          this.setState({
            branchSearchval: {
              value: branchSearchData.id,
              label: branchSearchData.branch_name
            },
            branch: branchSearchData.branch_name,
            branchError: "",
            branch_id: branchSearchData.id,
            getExamArr: getExamArr,
            examSelectedvalue: getExamArr,
            getClassArr: getClassArr,
            classSelectedvalue: getClassArr,
            getSectionArr: getSectionArr,
            sectionSelectedvalue: getSectionArr,
          });
        }

      }
    }
    // permissiontype
    if (name == "permissiontypeSearch") {
      if (value != "0") {
        let permissiontypeSearchData = this.props.getPermissionRequestTypes.find((a) => a.id == value);
        this.setState({
          permissiontypeSearchval: {
            value: permissiontypeSearchData.id,
            label: permissiontypeSearchData.permission_request_type
          },
          blockType: permissiontypeSearchData.id
        });
      } else {
        this.setState({
          permissiontypeSearchval: ""
        });
      }
    }


    this.setState({ [name]: value });

  }

  dropDownGetValues(fieldname, value) {
    let getArray = [];
    const newObj1 = {
      value: "0",
      label: "Select"
    }
    if (fieldname != "permissiontypeSearch" && fieldname != "branchSearch") {
      getArray.push(newObj1);
    }

    if (fieldname == "branchSearch") {
      this.props.globals.globalBranches.map((item) => {
        const newObj = {
          value: item.id,
          label: item.branch_name
        }
        getArray.push(newObj);
      });

    }
     if (fieldname == "permissiontypeSearch") {
      this.props.getPermissionRequestTypes.map((item) => {
        const newObj = {
          value: item.id,
          label: item.permission_request_type
        }
        getArray.push(newObj);
      });
    }
    return getArray;
  }

  tableData(students) {
    console.log("students", students);
    const student_data = Array();

    for (let i = 0; i < students.length; i++) {
      const branchs = this.props.globals.globalBranches.find(
        (e) => e.id == students[i].branch_id
      );
      let b_id = "";
      let branch1 = "";
      if (branchs != undefined) {
        branch1 = branchs.branch_name;
        b_id = branchs.id;
      }
      const exams = this.props.globals.exams.find(
        (e) => e.id == students[i].exam_id
      );
      let exam_id = "";
      let examName = "";
      if (exams != undefined) {
        examName = exams.exam;
        exam_id = exams.id;
      }

      const classes = this.props.globals.classes.find(
        (e) => e.id == students[i].class_id
      );
      let c_id = "";
      let class1 = "";
      if (classes != undefined) {
        class1 = classes.class;
        c_id = classes.id;
      }
      const sections = this.props.globals.globalSections.find(
        (e) => e.id == students[i].section_id
      );
      let s_id = "";
      let section1 = "";
      if (sections != undefined) {
        section1 = sections.section_name;
        s_id = sections.id;
      };

      student_data.push({
        id: students[i].id,
        student_name: students[i].student_name,
        exam_name: examName,
        exam_id: exam_id,
        branch_name: branch1,
        class_name: class1,
        section_name: section1,
        branch: b_id,
        class: c_id,
        section: s_id,
        student_roll_no: students[i].roll_no,
        parent_name: students[i].parent_name,
        parent_mobile: students[i].parent_mobile,
        request_date: moment.unix(students[i].request_date).format("DD-MM-YYYY"),
        individualPermissionData: students[i]
      });
    }
    return student_data;
  }

  articlecolumns = [
    {
      dataField: "student_name",
      text: "Student Name",
      sort: true,
    },

    {
      dataField: "student_roll_no",
      text: "Student Roll No.",
      sort: true,
    },
    {
      dataField: "parent_name",
      text: "Parent Name",
      sort: true,
    },
    {
      dataField: "parent_mobile",
      text: "Parent Mobile",
      sort: true,
    },
    {
      dataField: "branch_name",
      text: "Branch",
      sort: true,
    },
    {
      dataField: "exam_name",
      text: "Exam",
      sort: true,
    },
    {
      dataField: "class_name",
      text: "Class",
      sort: true,
    },
    {
      dataField: "section_name",
      text: "Section",
      sort: true,
    },
    {
      dataField: "request_date",
      text: "Request Date",
      sort: true,
    },
    {
      dataField: "View Details",
      formatter: this.performanceFunc.bind(this),
      text: "View Details"
    },

  ];

  performanceFunc(val, row) {
    console.log("rowwwwwwwwwww", row)
    return (<>
      <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ viewDetailsModal: true, individualPermissionData: row.individualPermissionData })}>
        <Button variant="link" name="edit" className="text-theme">
          <i className="fas fa-eye" />
        </Button>
      </div>
    </>)
  }

  applyCallback = (startDate, endDate) => {
    console.log("endDate", endDate);
    this.setState({
      startDateCalender: startDate.startOf('day').unix(),
      endDateCalender: endDate.endOf('day').unix(),
      noDateError: "",
    })
  }

  handleMultipleSelectInputChange = (e, name) => {

    console.log("multipleChange", e, name);


    if (name == "class") {

      let classSelectedvalue = [];
      let getSectionArr = [];

      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          const classval = e[i];
          const newObj = {
            label: classval.label,
            value: classval.value,
          }
          classSelectedvalue.push(newObj);
        }

        let selectedExamsValues = this.state.examSelectedvalue.map((item) => item.value);
        let selectedClasses = classSelectedvalue.map((item) => item.value);
        let uniqueSections = [];

        if (selectedClasses.length > 0) {
          selectedExamsValues.map((val) => {
            selectedClasses.map((val1) => {
              let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
              if (individualsectionValues.length > 0) {
                uniqueSections.push(...individualsectionValues)
              }
            })
          });
        }

        if (uniqueSections.length > 0) {
          [...new Set(uniqueSections)].map((val) => {
            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
            const newObj = {
              value: individualSectionData.id,
              label: individualSectionData.section_name
            }
            getSectionArr.push(newObj);
          });
        }


        this.setState({
          classSelectedvalue: classSelectedvalue,
          // classError: "",
          getSectionArr: getSectionArr,
          sectionSelectedvalue: getSectionArr,
        });
      } else {
        this.setState({
          classSelectedvalue: classSelectedvalue,
          // classError: "",
          getSectionArr: [],
          sectionSelectedvalue: [],
        });
      }
    }

    if (name == "exam") {
      let examSelectedvalue = [];

      if (e.length > 0) {

        for (let i = 0; i < e.length; i++) {
          const examval = e[i];
          const newObj = {
            label: examval.label,
            value: examval.value,
          }
          examSelectedvalue.push(newObj);
        }


        let selectedExamsValues = examSelectedvalue.map((item) => item.value);

        let uniqueClasses = [];
        let getClassArr = [];
        let getSectionArr = [];


        if (selectedExamsValues.length > 0) {

          selectedExamsValues.map((val) => {
            let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
            console.log("individualClassValues", individualClassValues);
            uniqueClasses.push(...individualClassValues)
          });
        }



        if (uniqueClasses.length > 0) {
          [...new Set(uniqueClasses)].map((val) => {

            console.log("uniqueClasses", val);

            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
            const newObj = {
              value: individualClassData.id,
              label: individualClassData.class
            }
            getClassArr.push(newObj);
          });

          let selectedClasses = getClassArr.map((item) => item.value);


          //section selection

          let uniqueSections = [];

          if (selectedClasses.length > 0) {
            selectedExamsValues.map((val) => {
              selectedClasses.map((val1) => {
                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                if (individualsectionValues.length > 0) {
                  uniqueSections.push(...individualsectionValues)
                }
              })
            });
          }

          if (uniqueSections.length > 0) {
            [...new Set(uniqueSections)].map((val) => {
              let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
              const newObj = {
                value: individualSectionData.id,
                label: individualSectionData.section_name
              }
              getSectionArr.push(newObj);
            });
          }
        }

        this.setState({
          examSelectedvalue: examSelectedvalue,
          examError: "",
          getClassArr: getClassArr,
          classSelectedvalue: getClassArr,
          getSectionArr: getSectionArr,
          sectionSelectedvalue: getSectionArr,

        });
      } else {
        this.setState({
          examSelectedvalue: [],
          getClassArr: [],
          classSelectedvalue: [],
          getSectionArr: [],
          sectionSelectedvalue: [],

        });
      }
    }

    if (name == "section") {

      let sectionSelectedvalue = [];

      if (e != null) {
        for (let i = 0; i < e.length; i++) {
          const sectionval = e[i];
          const newObj = {
            label: sectionval.label,
            value: sectionval.value,
          }
          sectionSelectedvalue.push(newObj);
        }
        this.setState({
          sectionSelectedvalue: sectionSelectedvalue,
          sectionError: "",
        });
      }
    }
  }

  render() {
    console.log("bunny", this.props.getParentsPermissionDetails);
    console.log("state", this.state);

    let StudentsFilterData = [];
    if (
      ( this.state.classSearch != "0" ||
        this.state.sectionSearch != "0" ||
        this.state.branchSearch != "0" ||
        this.state.examSearch != "0" ||
        this.state.permissiontypeSearch != "0")
    ) {
      StudentsFilterData = this.props.getParentsPermissionDetails;

      if (this.state.branchSearch != "0" && this.state.examSearch != "0" && this.state.classSearch != "0" && this.state.sectionSearch != "0") {
        StudentsFilterData = StudentsFilterData.filter((a) => a.branch_id == this.state.branchSearch && a.exam_id == this.state.examSearch && a.class_id == this.state.classSearch && a.section_id == this.state.sectionSearch);
      }
      if (this.state.branchSearch != "0" && this.state.examSearch != "0" && this.state.classSearch != "0") {
        StudentsFilterData = StudentsFilterData.filter((a) => a.branch_id == this.state.branchSearch && a.exam_id == this.state.examSearch && a.class_id == this.state.classSearch);
      }

      if (this.state.branchSearch != "0" && this.state.examSearch != "0") {
        StudentsFilterData = StudentsFilterData.filter((a) => a.branch_id == this.state.branchSearch && a.exam_id == this.state.examSearch);
      }

      if (this.state.branchSearch != "0") {
        StudentsFilterData = StudentsFilterData.filter((a) => a.branch_id == this.state.branchSearch);
      }
    }
    else {
      StudentsFilterData = this.props.getParentsPermissionDetails;
    }

    let eventData = StudentsFilterData.filter((item) => item.request_title != null && item.request_title != "" && parseInt(item.from_datetime) > +this.state.startDateCalender && parseInt(item.from_datetime) < +this.state.endDateCalender);

    const uniqueEventsDates = [...new Set(eventData.map((item) => item.from_datetime))]
    console.log("uniqueEventsDates", uniqueEventsDates);

    let permissionRequestType = [];

    if (this.state.permissiontypeSearch != "0") {
      permissionRequestType = StudentsFilterData.filter((a) => a.permission_request_type_id == this.state.permissiontypeSearch)
    } else {
      permissionRequestType = StudentsFilterData
    }

    let permissionFilterData = []
    if (this.state.blockType == "1") {
      permissionFilterData = permissionRequestType.filter((item) => item.permission_status == null)
    } else if (this.state.blockType == "2") {
      permissionFilterData = permissionRequestType.filter((item) => item.permission_status == "1")
    }
    else if (this.state.blockType == "3") {
      permissionFilterData = permissionRequestType.filter((item) => item.permission_status == "2")
    }
    console.log("permissionFilterData", permissionFilterData);

    let examselectall = true;
    let examlabelledBy = "Select";
    let examdisableSearch = false;

    let classselectall = true;
    let classlabelledBy = "Select";
    let classdisableSearch = false;

    let sectionselectall = true;
    let sectionlabelledBy = "Select";
    let sectiondisableSearch = false;

    if (this.props.globals.classes.length > 0) {
      classselectall = true;
      classdisableSearch = false;
    }
    else {
      classdisableSearch = true;
      classselectall = false;
      classlabelledBy = "Class"
    }

    if (this.props.globals.exams.length > 0) {
      examselectall = true;
      examdisableSearch = false;
    }
    else {
      examdisableSearch = true;
      examselectall = false;
      examlabelledBy = "Exam"
    }

    if (this.props.globals.globalSections.length > 0) {
      sectionselectall = true;
      sectiondisableSearch = false;
    }
    else {
      sectiondisableSearch = true;
      sectionselectall = false;
      sectionlabelledBy = "Section"
    }
    return (
      <section className='student-table'>
        <Container fluid>
          <Row className="mt-3">
            <Col xl={12} lg={12} md={12} sm={12}>
            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
            <h2 className="title h5 mb-0">Permissions</h2>
                            <div className="filter-block d-flex align-items-center mr-4">
                            <button className="button-41 mr-3" onClick={() => { this.setState({ viewSingleRequestModal: true }) }}>Individual Request</button>
                            <button className="button-42" onClick={() => { this.setState({ viewMultipleRequestModal: true }) }}>Multi Request</button>

                            </div>
                        </div>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12}>
                  <Row>
                    <Col sm={2}>
                      <h6 className="font-weight-bold mt-2"><span className="text-danger"> * </span>Branch</h6>
                      <SelectDropDown
                        stateData={this.state.branchSearchval}
                        handleChange={this.selecthandleInputChange}
                        name="branchSearch"
                        options={this.dropDownGetValues("branchSearch")}
                        placeholderName={'Brnch Type'}
                        dropdownIndicator={{ DropdownIndicator }} />
                    </Col>

                    <Col sm={2}>
                      <h6 className="font-weight-bold mt-2"><span className="text-danger"> * </span>Exam</h6>
                      <MultiSelect
                        overrideStrings={{
                          "allItemsAreSelected": "All Exams are selected.",
                          "selectSomeItems": examlabelledBy
                        }}
                        disableSearch={examdisableSearch}
                        hasSelectAll={examselectall}
                        options={this.state.getExamArr}
                        value={this.state.examSelectedvalue}
                        onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                        labelledBy={"exam"}
                      />
                    </Col>

                    <Col sm={2}>
                      <h6 className="font-weight-bold mt-2"><span className="text-danger"> * </span>Class</h6>
                      <MultiSelect
                        overrideStrings={{
                          "allItemsAreSelected": "All Classes are selected.",
                          "selectSomeItems": classlabelledBy
                        }}
                        disableSearch={classdisableSearch}
                        hasSelectAll={classselectall}
                        options={this.state.getClassArr}
                        value={this.state.classSelectedvalue}
                        onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                        labelledBy={"class"}
                      />
                    </Col>

                    <Col sm={2}>
                      <h6 className="font-weight-bold mt-2"><span className="text-danger"> * </span>Section</h6>
                      <MultiSelect
                        overrideStrings={{
                          "allItemsAreSelected": "All Sections are selected.",
                          "selectSomeItems": sectionlabelledBy
                        }}
                        disableSearch={sectiondisableSearch}
                        hasSelectAll={sectionselectall}
                        options={this.state.getSectionArr}
                        value={this.state.sectionSelectedvalue}
                        onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                        labelledBy={"section"}
                      />
                    </Col>

                    <Col sm={2}>
                      <h6 className="font-weight-bold mt-2"><span className="text-danger"> * </span>Request Types</h6>
                      <SelectDropDown
                        stateData={this.state.permissiontypeSearchval}
                        handleChange={this.selecthandleInputChange}
                        name="permissiontypeSearch"
                        options={this.dropDownGetValues("permissiontypeSearch")}
                        placeholderName={'Permission Type'}
                        dropdownIndicator={{ DropdownIndicator }}
                      />
                    </Col>
                  </Row>
                  </Col>
                  {
                    this.state.permissiontypeSearch == "2" ? (

                      <Row className='ml-3 mt-5'>
                        <Col xl={12} lg={12} md={12} sm={12}>
                          <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">Student Events</h2>
                            <div className="filter-block d-flex align-items-center mr-4">
                              <Form.Group className="customDate mb-0 mr-4" controlId="StartDate" style={{ width: 180 }}>
                                <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end} data="student_Permission" />
                              </Form.Group>
                            </div>
                          </div>
                        </Col>
                          <Col lg={12} md={12} sm={12} className='mt-2'>
                            {
                              uniqueEventsDates.length > 0 ? (
                                <Table className="table  table-bordered">
                                  <thead>
                                    <tr className='tableHeading'>
                                      <th rowSpan="2">Sno</th>
                                      <th rowSpan="2">Date</th>
                                      <th rowSpan="2" className=''>Event Name</th>
                                      <th rowSpan="2" className=''>Total Students</th>
                                      <th colSpan="2" className='ml-3'>In Campus</th>
                                      <th colSpan="2">Return to Campus</th>
                                    </tr>
                                    <tr className='tableHeading'>
                                      <th>In </th>
                                      <th>Exit </th>
                                      <th>Entry</th>
                                      <th>Out</th>
                                    </tr>
                                  </thead>
                                  <tbody className=''>
                                    {
                                      uniqueEventsDates.map((item, index) => {
                                        let sno = index + 1;
                                        let date = moment.unix(item).format("DD-MM-YYYY");
                                        let eventName = eventData.find((item1) => item1.from_datetime == item)
                                        console.log("evvvv", eventName);

                                        console.log("eventData", eventData.filter((item1) => item1.from_datetime == item && item1.request_title == eventName));
                                        return (
                                          <>
                                            <tr className=''>
                                              <td style={{ textAlign: "center" }}>{sno}</td>
                                              <td style={{ textAlign: "center" }}>{date}</td>
                                              <td style={{ textAlign: "center" }}>{eventName.request_title}</td>

                                              {/* Total */}
                                              <td className="tableBodyHome " onClick={() => {
                                                const totalFilterData = eventData.filter(item1 => (
                                                  item1.from_datetime == item
                                                ))
                                                if (totalFilterData.length > 0) {
                                                  this.setState({

                                                    permissionModalShow: true, sendStudentsNotificationList: totalFilterData, template_name: "Holiday Hostel Pickup!"
                                                  })
                                                }
                                              }}>{
                                                  eventData.filter((item1) => item1.from_datetime == item).length
                                                }</td>

                                              {/* IN PRESENT */}
                                              <td className="tableBodyHome " onClick={() => {
                                                const present_students = eventData.filter(item1 => item1.from_datetime == item && (item1.outtime === "" || item1.outtime === null))
                                                if (present_students.length > 0) {
                                                  this.setState({
                                                    permissionModalShow: true, sendStudentsNotificationList: present_students, template_name: "Urgent: Hostel Pickup Reminder"
                                                  })
                                                }
                                              }}>{
                                                  eventData.filter((item1) => item1.from_datetime == item && (item1.outtime === "" || item1.outtime === null)).length
                                                }</td>

                                              {/* EXIT */}
                                              <td className="tableBodyHome " onClick={() => {
                                                const filterExitdata = eventData.filter(
                                                  item1 =>
                                                    item1.from_datetime == item &&
                                                    item1.outtime != "" && item1.outtime != null
                                                )
                                                if (filterExitdata.length > 0) {
                                                  this.setState({
                                                    permissionModalShow: true, sendStudentsNotificationList: filterExitdata, template_name: "Important: Child Vacation Departure & Home Arrival Check"
                                                  })
                                                }
                                              }}>{
                                                  eventData.filter((item1) => item1.from_datetime == item && (item1.outtime != "" && item1.outtime != null)).length
                                                }</td>

                                              {/* IN ENTRY */}
                                              <td className="tableBodyHome " onClick={() => {
                                                const filteredEventData = eventData.filter(
                                                  item1 =>
                                                    item1.from_datetime === item &&
                                                    item1.intime !== null &&
                                                    item1.intime !== "" &&
                                                    item1.outtime !== null &&
                                                    item1.outtime !== ""
                                                );

                                                if (filteredEventData.length > 0) {
                                                  this.setState({
                                                    permissionModalShow: true,
                                                    sendStudentsNotificationList: filteredEventData, template_name: "Important: Child Vacation College Arrival Check"
                                                  });
                                                }
                                              }}>
                                                {eventData.filter(item1 =>
                                                  item1.from_datetime === item && (item1.intime !== "" && item1.intime !== null) && (item1.outtime !== "" && item1.outtime !== null)
                                                ).length}
                                              </td>

                                              {/* OUT */}
                                              <td className="tableBodyHome" onClick={() => {
                                                const non_returned_Students = eventData.filter(item1 => (
                                                  item1.from_datetime == item &&
                                                  (item1.intime === "" || item1.intime === null) && (item1.outtime != "" && item1.outtime != null)
                                                ))
                                                if (non_returned_Students.length > 0) {
                                                  this.setState({
                                                    permissionModalShow: true, sendStudentsNotificationList: non_returned_Students, template_name: "Action Required: Ward Return Post Holiday Break"
                                                  })
                                                }
                                              }}>{
                                                  eventData.filter(item1 =>
                                                    item1.from_datetime == item &&
                                                    (item1.intime === "" || item1.intime === null) && (item1.outtime != "" && item1.outtime != null)
                                                  ).length
                                                }</td>

                                            </tr>
                                          </>
                                        )
                                      })
                                    }
                                  </tbody>
                                </Table>
                              ) : (
                                <Row>
                                  <Col xs={12} md={12} sm={12} className="d-flex align-items-center justify-content-md-center">
                                    <h4 className='mt-3 text-center'><span className="text-danger"> * </span>  No data available</h4>
                                  </Col>
                                </Row>
                              )
                            }
                          </Col>
                      </Row>
                    ) : (
                      <Container fluid className='studentPermission mt-5'>
                        <Card>
                        <Card.Body className='ml-3'>
                        <Row>
                          <Col sm={4} className='mt-4 mb-3 ml-3'>
                            <Card className={this.state.blockType == "1" ? "active block_view_Details" : "block_view_Details"} onClick={() => this.setState({ blockType: "1" })}>
                              <Card.Body>
                                <h5 className="text-center"><span className='title_alignment'>Requested</span></h5>
                              </Card.Body>
                            </Card>
                          </Col>
                          <Col sm={4} className='mt-4 mb-3'>
                            <Card className={this.state.blockType == "2" ? "active block_view_Details1" : "block_view_Details1"} onClick={() => this.setState({ blockType: "2" })}>
                              <Card.Body>
                                <h5 className="text-center"><span className='title_alignment'>Accepted</span></h5>
                              </Card.Body>
                            </Card>
                          </Col>
                          <Col sm={3} className='mt-4 mb-3'>
                            <Card className={this.state.blockType == "3" ? "active block_view_Details2" : "block_view_Details2"} onClick={() => this.setState({ blockType: "3" })}>
                              <Card.Body>
                                <h5 className="text-center"><span className='title_alignment'>Declined</span></h5>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={12}>                          
                          {
                            this.state.blockType == "1" ?(
                                permissionFilterData.length > 0 ? (
                                    <CardLessDataTableWithSearch
                                      parentData={this.tableData(permissionFilterData)}
                                      particlecolumns={this.articlecolumns}
                                      name="attendance"
                                    />
                                  ) : (
                                    <Col ls={12} md={12} sm={12}>
                                      <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                    </Col>
                                  )
                              )
                              : this.state.blockType == "2" ? (
                                  permissionFilterData.length > 0 ? (
                                    <CardLessDataTableWithSearch
                                      parentData={this.tableData(permissionFilterData)}
                                      particlecolumns={this.articlecolumns}
                                      name="attendance"
                                    />
                                  ) : (
                                    <Col ls={12} md={12} sm={12}>
                                      <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                    </Col>
                                  )
                                ):
                                this.state.blockType == "3" ?
                                  permissionFilterData.length > 0 ? (
                                    <CardLessDataTableWithSearch
                                      parentData={this.tableData(permissionFilterData)}
                                      particlecolumns={this.articlecolumns}
                                      name="attendance"
                                    />
                                  ) : (
                                    <Col ls={12} md={12} sm={12}>
                                      <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                    </Col>
                             ): ""
                          }
                          </Col>
                        </Row>
                        </Card.Body>
                        </Card>
                      </Container>
                    )
                  }
          </Row>
          <PermissionDetailsModal
            stateData={this.state}
            show={this.state.viewDetailsModal}
            onHide={() => this.setState({ viewDetailsModal: false })}
          />
          <SingleRequestModal
            stateData={this.state}
            show={this.state.viewSingleRequestModal}
            onHide={() => this.setState({ viewSingleRequestModal: false })}
            globals={this.props.globals}
            getParentsPermissionDetails={this.props.getParentsPermissionDetails}
          />
          <MultipleRequestModal
            stateData={this.state}
            show={this.state.viewMultipleRequestModal}
            onHide={() => this.setState({ viewMultipleRequestModal: false })}
            globals={this.props.globals}
            getParentsPermissionDetails={this.props.getParentsPermissionDetails}
          />
          <PermissionModal
            stateData={this.state}
            show={this.state.permissionModalShow}
            onHide={() => this.setState({ permissionModalShow: false })}
          />
        </Container>
      </section>
    )
  }
}

export default StudentPermissionHome;